/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  baseUrl: 'https://payment-dev.livinghub.com.br',
  apiUrl: 'https://backend-dev.livinghub.com.br',
  stripe: {
    publicKey:
      'pk_test_51LW6ExJ7lGNXSjJbB0K25TfCx8vTMmJICnF8whtxPJyqGu95IiV8wAedHYlziKAIrSsQytHGp37CjolE237aFimb00YTpXGGKx',
  },
  firebase: {
    apiKey: 'AIzaSyB_yR6ILF8E0h_e5chuCTOvowFuLKkncL0',
    authDomain: 'jflliving-ae2f3.firebaseapp.com',
    projectId: 'jflliving-ae2f3',
    storageBucket: 'jflliving-ae2f3.firebasestorage.app',
    messagingSenderId: '710870415979',
    appId: '1:710870415979:web:a51f537eee5edc7a85cf2e',
    measurementId: 'G-7XT07B300L',
  },
};
